export default __webpack_public_path__ + "static/media/companyformation.0df7fd80.jpg";